/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 1/13/16.
 */
'use strict';
angular.module('prism-ui.livefeed').controller('LiveFeedEditController',
	function ($routeParams, $scope, BreadcrumbService, LiveFeedEditService, LivefeedsResourceFactory) {
		var self = this;

		LiveFeedEditService.EditDataResource = LivefeedsResourceFactory;
		BreadcrumbService.editService = LiveFeedEditService;
		self.editService = LiveFeedEditService;

		self.loadingIndicator = {
			backdrop: true,
			show: false,
			title: 'Working',
			message: 'Please wait...'
		};

        self.toolbarButtonDefs = [
            {
                label: 'Save',
                enabled: function() {
                    return (
                        self.editorForm &&
                        !self.editorForm.$pristine &&
                        self.editorForm.$valid
                    );
                },
                onClick: function() {
                    $scope.$broadcast('server-busy', {working: true});
                    LiveFeedEditService.saveEditData().then(function () {
                        self.editData = LiveFeedEditService.editData;
                        $scope.$broadcast('server-busy', {working: false});
                    });
                }
            }, {
                label: 'Revert',
                enabled: function() {
                    return $routeParams.id <= -1 || (
                        self.editorForm &&
                        !self.editorForm.$pristine
                    );
                },
                onClick: function() {
                    LiveFeedEditService.revertEditData();
                    self.editData = LiveFeedEditService.editData;
                }
            }, {
                label: 'Close',
                enabled: function() { return true; },
                onClick: function() {
                    LiveFeedEditService.exitEdit();
                }
            }
        ];

		$scope.$watch(function () {
			return self.editorForm;
		}, function () {
			if (self.editorForm) {
				LiveFeedEditService.editorForm = self.editorForm;
			}
		});

		$scope.$on('server-busy', function (event, options) {
			self.loadingIndicator.show = options.working;
		});

		$scope.$on('$destroy', function () {
			BreadcrumbService.editService = null;
			LiveFeedEditService.resetServiceData();
		});

		$scope.$broadcast('server-busy', {working: true});
		LiveFeedEditService.getEditData().then(function () {
			self.editData = LiveFeedEditService.editData;
			$scope.$broadcast('server-busy', {working: false});
		});
	});
